export default __webpack_public_path__ + "static/media/section-important.d82e2547.mp4";